import { useRef, useState } from "react";
import { CloudUpload } from "lucide-react";
import { AttachmentItem } from "@/components/form/AttachmentItem";
import { MAX_FILES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const AttachmentUploader = ({ items, onAdd, onRemove }) => {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const full = items.length >= MAX_FILES;

  const handleFiles = (files) => {
    if (files?.length) onAdd(files);
    if (inputRef.current) inputRef.current.value = "";
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (!full) handleFiles(e.dataTransfer.files);
  };

  return (
    <div className="space-y-3">
      <label
        htmlFor="attachment-input"
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={onDrop}
        data-testid="attachment-dropzone"
        className={cn(
          "flex cursor-pointer flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed px-4 py-8 text-center transition-colors duration-200",
          dragging ? "border-emerald-500 bg-emerald-50" : "border-slate-200 bg-slate-50/70 hover:border-emerald-400 hover:bg-emerald-50/50",
          full && "pointer-events-none opacity-50",
        )}
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-emerald-600 shadow-sm ring-1 ring-slate-200">
          <CloudUpload className="h-6 w-6" />
        </span>
        <span className="font-heading text-sm font-semibold text-slate-800">
          {full ? `Batas ${MAX_FILES} lampiran tercapai` : "Pilih atau seret foto / video ke sini"}
        </span>
        <span className="text-xs text-slate-500">Maks. {MAX_FILES} file · 25MB per file · semua format foto &amp; video</span>
        <input
          id="attachment-input"
          ref={inputRef}
          type="file"
          accept="image/*,video/*"
          multiple
          disabled={full}
          className="sr-only"
          onChange={(e) => handleFiles(e.target.files)}
          data-testid="attachment-input"
        />
      </label>
      <div className="flex justify-between text-xs text-slate-500">
        <span>Lampiran bersifat opsional</span>
        <span data-testid="attachment-count">{items.length}/{MAX_FILES} lampiran</span>
      </div>
      {items.length > 0 && (
        <ul className="space-y-2" data-testid="attachment-list">
          {items.map((item, i) => (
            <AttachmentItem key={item.key} item={item} index={i} onRemove={() => onRemove(item.key)} />
          ))}
        </ul>
      )}
    </div>
  );
};
